import { lazy } from 'react';

const DirectSalesContent = import(
  'components/direct-sales-landing/components/DirectSalesContent'
);
const DirectSalesSidebarRight = import(
  'components/direct-sales-landing/components/DirectSalesSidebarRight'
);
const DirectSalesHeader = import(
  'components/direct-sales-landing/components/DirectSalesHeader'
);
const DirectSalesFooter = import(
  'components/direct-sales-landing/components/DirectSalesFooter'
);

const DirectSalesLanding = {
  Content: lazy(() => DirectSalesContent),
  RightSidebar: lazy(() => DirectSalesSidebarRight),
  Header: lazy(() => DirectSalesHeader),
  Footer: lazy(() => DirectSalesFooter)
}

export default DirectSalesLanding;